import { useTheme } from 'styled-components';
import { ActionsGroup } from '../Actions.styled';
import { MyLocationIcon } from '@medly-components/icons';
import { useRegionContext } from 'context/RegionContext';
import { useCustomNavigate } from 'hooks/useCustomNavigate';
import { useLocation } from 'react-router-dom';
import { useMapController } from '../../../hooks/useMapController';
import { ZoneSwitchState } from '../../../Zone';
import { useEffect, useState } from 'react';
import { useMapParams } from 'hooks/useMapParams';

export const CurrentLocation = () => {
    const { colors } = useTheme();
    const { region } = useRegionContext();
    const { zoomToCurrentLocation } = useMapController();
    const { switchMapZone } = useCustomNavigate();
    const { zoneName } = useMapParams();
    const location = useLocation();
    const _isCurrentLocationActive = (location.state as ZoneSwitchState)?.isCurrentLocationActive;
    const [isCurrentLocationActive, setIsCurrentLocationActive] = useState(_isCurrentLocationActive);

    useEffect(() => {
        if (isCurrentLocationActive) {
            setTimeout(() => {
                setIsCurrentLocationActive(false);
            }, 5000);
        }
    }, [isCurrentLocationActive]);

    const onGoToCurrentLocation = () => {
        if (!region.position?.zone || zoneName === region.position.zone) {
            zoomToCurrentLocation();
            setIsCurrentLocationActive(true);
            return;
        }

        switchMapZone(zoneName, region.position.zone, { state: { isCurrentLocationActive: true } });
    };

    return (
        <ActionsGroup>
            <MyLocationIcon
                data-testid="current-location"
                size="S"
                variant="solid"
                bgColor={colors.white}
                iconColor={isCurrentLocationActive ? colors.coral[500] : colors.darkBlue}
                onClick={onGoToCurrentLocation}
            />
        </ActionsGroup>
    );
};
